import { UserType } from '../../types/users';

interface checkPermissionProps {
  user: UserType;
  permissionId: string;
}
export const checkPermission = ({ user, permissionId }: checkPermissionProps) => {
  return user?.role.permissions.some((permission) => permission.id === permissionId);
};
